export class Example {
    sentence: string;
    explanation: string;

    constructor(sentence: string, explanation: string) {
        this.sentence = sentence;
        this.explanation = explanation;
    }
}